var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPharmuni = function SvgPharmuni(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    d: "M13.004.336V50L20 43.728V.336a18.428 18.428 0 0 0-7 0M27 4v26.096L27.098 37 33 31.012V17.048C33 11.713 30.642 6.976 27 4ZM0 17.172V62l7-6.147V4c-4.253 3.004-7 7.786-7 13.172Z"
  })));
};
export default SvgPharmuni;